//import React, {useState, useEffect} from 'react';
import Home from './Home';
import { usePushNotifications } from './utils/usePushNotifications'; // Import the hook



function App() {
  usePushNotifications();
  return (
  <Home></Home>
  );
}

export default App;